import { Injectable, OnInit } from '@angular/core';

@Injectable()
export class EcomHtmlUtils implements OnInit {
    // component initialize and load the required data
    ngOnInit() {
    }

    // Method to truncate the text 
    textTruncate(str, length = null, ending = null) {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    }

    // Method to sort the array
    arraySort(objectList: any[], sortProperty: any, orderby = 'asc') {
        return objectList.sort((a, b) => (a['sortProperty'] > b['sortProperty']) ? 1 : -1);
    }

}